import { normalizeRequestError } from './http'

// 只有浏览器授权管理POST携带同源Cookie；数据、WS与控制仍使用各自受限短凭据。
export function createSharedBrowserClient ({ code, current, fetcher = (...args) => fetch(...args) }) {
  if (!/^[a-f0-9]{64}$/.test(code) || typeof current !== 'function') throw new Error('分享地址无效')
  const controllers = new Set()
  const request = async (action, data = {}) => {
    if (!current()) throw new Error('分享页面已离开')
    if (!['_session', '_resume', '_renew', '_remember', '_forget'].includes(action)) throw new Error('浏览器访问接口无效')
    const keys = action === '_session' ? ['password', 'browserSessionVersion', 'accessId', 'remember'] : action === '_forget' ? [] : ['accessId', 'remember']
    if (!data || typeof data !== 'object' || Array.isArray(data) || Object.keys(data).some(key => !keys.includes(key)) ||
        (action !== '_forget' && !/^[a-f0-9]{32}$/.test(data.accessId || '')) ||
        (data.remember !== undefined && typeof data.remember !== 'boolean') ||
        (action === '_session' && (data.browserSessionVersion !== 1 || (data.password !== undefined && (typeof data.password !== 'string' || data.password.length > 128))))) throw new Error('浏览器访问参数无效')
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 15000)
    controllers.add(controller)
    try {
      const response = await fetcher('/jetlinks/visualization/share/' + code + '/browser/' + action, {
        method: 'POST', credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: controller.signal,
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Visualization-Browser': '1' }, body: JSON.stringify(data)
      })
      let result
      try { result = await response.json() } catch (_) { throw { response: { status: response.ok ? 502 : response.status, data: {} } } }
      if (!current()) throw new Error('分享页面已离开')
      if (!response.ok) throw { response: { status: response.status, data: result, headers: response.headers } }
      return { status: response.status, data: result }
    } catch (cause) {
      throw cause && cause.response ? normalizeRequestError(cause) : cause && cause.name === 'AbortError' ? normalizeRequestError({ code: 'ECONNABORTED' }) : cause instanceof TypeError ? normalizeRequestError(cause) : cause
    } finally { clearTimeout(timer); controllers.delete(controller) }
  }
  request.close = () => { controllers.forEach(controller => controller.abort()); controllers.clear() }
  return request
}

export function shareAccessId (code, storage, crypto = window.crypto) {
  const key = 'visualization-share-access:' + code
  try { if (storage === undefined) storage = window.sessionStorage; const value = storage.getItem(key); if (/^[a-f0-9]{32}$/.test(value || '')) return value } catch (_) { /* 存储被禁用时只在当前页面保留编号。 */ }
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  const value = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
  try { storage.setItem(key, value) } catch (_) { /* 不能把存储失败当成授权失败。 */ }
  return value
}

export function withShareBrowserLock (code, task, locks = window.navigator && window.navigator.locks) {
  if (!locks || typeof locks.request !== 'function') return task()
  let entered = false
  return locks.request('visualization-share:' + code, () => { entered = true; return task() }).catch(cause => {
    if (!entered && ['SecurityError', 'NotSupportedError'].includes(cause.name)) return task()
    throw cause
  })
}
